import once from "lodash.once"

import { Analytics } from "utils/analytics"

const twoWeeksMs = 14 * 24 * 3600000

export const analyticsEvents = once((slots: string[]) => {
    const currentDatetime = new Date()
    const currentDateMs = currentDatetime.getTime()
    const slotsCount = slots.length
    if (slotsCount === 0) return
    slots.forEach((date) => {
        const ms = new Date(date).getTime()
        if (ms - currentDateMs <= twoWeeksMs) {
            Analytics.free_slot()
        }
    })
    const eventValue = [3, 5, 8].reduce((prev, current) => {
        if (slotsCount < current) return prev
        return current
    }, 0)
    if (eventValue > 0) {
        Analytics[`free_slots_${eventValue}`]()
    }
})
